import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcAliveData, RpcAliveKey } from './rpc-alive-model';

export class RpcAliveClient {
    /**
     * The alive command.
     *
     * @param rpc the Rpc instance.
     * @param data the Rpc alive data object.
     * @return Promise<void> the promise object.
     */
    public static alive(rpc: Rpc, data?: RpcAliveData): Promise<void> {
        if (!data) {
            data = { timestamp: Date.now() };
        }

        return RpcInboundClient.call(rpc, RpcAliveKey.command, RpcAliveKey.version, data);
    }

    /**
     * The alive forever command.
     *
     * @param rpc the Rpc instance.
     * @return Promise<void> the promise object.
     */
    public static forever(rpc: Rpc): Promise<void> {
        const data: RpcAliveData = { timestamp: Date.now(), forever: true };
        return RpcInboundClient.call(rpc, RpcAliveKey.command, RpcAliveKey.version, data);
    }

    /**
     * The reset forever state command.
     *
     * @param rpc the Rpc instance.
     * @return Promise<void> the promise object.
     */
    public static reset(rpc: Rpc): Promise<void> {
        const data: RpcAliveData = { timestamp: Date.now(), forever: false };
        return RpcInboundClient.call(rpc, RpcAliveKey.command, RpcAliveKey.version, data);
    }
}
